import React from "react";
import { useCrmCopy } from "../crmI18n";

export default function CrmSectionPage({ sectionKey, title, eyebrow, columns }) {
  const copy = useCrmCopy();
  const sectionCopy = copy.sections[sectionKey] || {};
  const resolvedColumns = columns || sectionCopy.columns || [];
  const resolvedTitle = title || sectionCopy.title || copy.common.crm;

  return (
    <main className={`crm-page crm-page--compactTable crm-page--sectionPage crm-page--${sectionKey}`}>
      <header className="crm-pageHeader">
        <div>
          <p className="crm-eyebrow">{eyebrow || copy.common.crm}</p>
          <h1>{resolvedTitle}</h1>
        </div>
      </header>

      <section className="crm-panel">
        <div className="crm-tableShell">
          <table className="crm-table">
            <thead>
              <tr>
                {resolvedColumns.map((column) => (
                  <th key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={Math.max(resolvedColumns.length, 1)}>
                  <div className="crm-tableEmpty">{copy.common.noRecords}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </main>
  );
}
